import { Controller } from 'stimulus';
import _ from 'lodash';
import { render, h, React, Fragment, Component, createRef } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import Utility from "../classes/Utility";
import RequestQueue from '../classes/RequestQueue';
import morphdom from 'morphdom';
import WatchlistButton from '../data_services/preact-components/WatchlistButton';
import { delegate } from 'tippy.js';
import MitreTable from "../utils/mitre-table";
import classNames from 'classnames';
import axios from 'axios';

const SORTED_CELL_MARK_CLASS = 'sorted-cell';
const SORTED_CELL_STYLING_CLASSES = ['t-bg-mitre-green-100', 't-font-medium', SORTED_CELL_MARK_CLASS];
const SORTED_CELL_BACKGROUND_CLASS = 't-bg-mitre-green-100';
const UNSORTED_CELL_STYLING_CLASSES = ['t-bg-inherit'];

const HEADER_Z_INDEX = 't-z-30';

var SORTED_HEADER_BUTTON_STYLING_CLASSES = ['t-text-mitre-blue-200', 't-font-semibold', 'm-table-col__in-sort'];
var HOVERED_ROW_CLASSES = 'm-table-body-row-container__hovered';


const EmailCaptureForm = ({ cancelText, onCancel, submitText, onSubmit }) => {

  const [email, setEmail] = useState();
  const [investorType, setInvestorType] = useState();

  const [emailValidationError, setEmailValidationError] = useState(false);
  const [investorTypeValidationError, setInvestorTypeValidationError] = useState(false);

  const validateEmail = (email) => {
    return (/^\w+([\.\-\+]?\w+)*@\w+([\.\-]?\w+)*(\.\w{2,3})+$/.test(email));
  };

  const cancelHandler = async (event) => {
    event.preventDefault();
    await onCancel();
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    const isEmalValid = validateEmail(email);
    const isInvestorTypePresent = !!investorType;

    if (isEmalValid && isInvestorTypePresent) {
      await onSubmit({ email, investorType });
    } else {
      setEmailValidationError(!isEmalValid);
      setInvestorTypeValidationError(!isInvestorTypePresent);
    }
  };

  return (
    <div>
      <div class="t-mb-2">
        <input class={classNames('m-page-email-capture-input-field t-border-2 t-rounded-md', {
            't-border-mitre-red-100': emailValidationError,
          })}
          placeholder="EMAIL ADDRESS"
          onChange={(event) => setEmail(event.target.value.trim())}
          type="text"
          />
      </div>
      <div class="t-mb-2">
        <select class={classNames('t-text-sm t-appearance-none  t-border-2 t-rounded-md t-p-4 t-w-full', {
            't-border-mitre-red-100': investorTypeValidationError,
          })}
          onChange={(event) => setInvestorType(event.target.value)}
          placeholder="INVESTOR TYPE">
          <option disabled="" hidden="" label="INVESTOR TYPE" selected=""></option>
          <optgroup label="Advisor">
            <option id="AdvisorWirehouse" key="AdvisorWirehouse" label="Wirehouse" value="AdvisorWirehouse">Wirehouse</option>
            <option id="AdvisorRIA" key="AdvisorRIA" label="RIA" value="AdvisorRIA">RIA</option>
            <option id="AdvisorIBD" key="AdvisorIBD" label="IBD" value="AdvisorIBD">IBD</option>
          </optgroup>
          <optgroup label="Retirement Plan Advisor">
            <option id="RetirementPlanAdvisorWirehouse" key="RetirementPlanAdvisorWirehouse" label="Wirehouse" value="RetirementPlanAdvisorWirehouse">Wirehouse</option>
            <option id="RetirementPlanAdvisorRIA" key="RetirementPlanAdvisorRIA" label="RIA" value="RetirementPlanAdvisorRIA">RIA</option>
            <option id="RetirementPlanAdvisorIBD" key="RetirementPlanAdvisorIBD" label="IBD" value="RetirementPlanAdvisorIBD">IBD</option>
          </optgroup>
          <optgroup label="Institutional">
            <option id="InstitutionalBank" key="InstitutionalBank" label="Bank" value="InstitutionalBank">Bank</option>
            <option id="InstitutionalCorporate" key="InstitutionalCorporate" label="Corporate" value="InstitutionalCorporate">Corporate</option>
            <option id="InstitutionalCreditUnion" key="InstitutionalCreditUnion" label="Credit Union" value="InstitutionalCreditUnion">Credit Union</option>
            <option id="InstitutionalEndowmentFund" key="InstitutionalEndowmentFund" label="Endowment Fund" value="InstitutionalEndowmentFund">Endowment Fund</option>
            <option id="InstitutionalETFIssuer" key="InstitutionalETFIssuer" label="ETF Issuer" value="InstitutionalETFIssuer">ETF Issuer</option>
            <option id="InstitutionalFamilyOffice" key="InstitutionalFamilyOffice" label="Family Office" value="InstitutionalFamilyOffice">Family Office</option>
            <option id="InstitutionalHedgeFund" key="InstitutionalHedgeFund" label="Hedge Fund" value="InstitutionalHedgeFund">Hedge Fund</option>
            <option id="InstitutionalHospital" key="InstitutionalHospital" label="Hospital" value="InstitutionalHospital">Hospital</option>
            <option id="InstitutionalMutualFund" key="InstitutionalMutualFund" label="Mutual Fund Company" value="InstitutionalMutualFund">Mutual Fund Company</option>
            <option id="InstitutionalNonProfit" key="InstitutionalNonProfit" label="Non-profit" value="InstitutionalNonProfit">Non-profit</option>
            <option id="InstitutionalPensionFund" key="InstitutionalPensionFund" label="Pension Fund" value="InstitutionalPensionFund">Pension Fund</option>
            <option id="InstitutionalPrivateEquity" key="InstitutionalPrivateEquity" label="Private Equity" value="InstitutionalPrivateEquity">Private Equity</option>
            <option id="InstitutionalPublicEntity" key="InstitutionalPublicEntity" label="Public entity (e.g. Government)" value="InstitutionalPublicEntity">Public entity (e.g. Government)</option>
            <option id="InstitutionalRealEstate" key="InstitutionalRealEstate" label="Real Estate" value="InstitutionalRealEstate">Real Estate</option>
            <option id="InstitutionalSchool" key="InstitutionalSchool" label="School" value="InstitutionalSchool">School</option>
            <option id="InstitutionalSecuritiesBrokerage" key="InstitutionalSecuritiesBrokerage" label="Securities brokerage" value="InstitutionalSecuritiesBrokerage">Securities brokerage</option>
            <option id="InstitutionalSovereignWealthFund" key="InstitutionalSovereignWealthFund" label="Sovereign Wealth Fund" value="InstitutionalSovereignWealthFund">Sovereign Wealth Fund</option>
            <option id="InstitutionalTrust" key="InstitutionalTrust" label="Trust" value="InstitutionalTrust">Trust</option>
            <option id="InstitutionalVentureCapital" key="InstitutionalVentureCapital" label="Venture Capital" value="InstitutionalVentureCapital">Venture Capital</option>
          </optgroup>
          <optgroup label="Insurance Agent">
            <option id="InsuranceAgentIndependent" key="InsuranceAgentIndependent" label="Independent" value="InsuranceAgentIndependent">Independent</option>
            <option id="InsuranceAgentRIA" key="InsuranceAgentRIA" label="RIA affiliated" value="InsuranceAgentRIA">RIA affiliated</option>
            <option id="InsuranceAgentCaptive" key="InsuranceAgentCaptive" label="Captive" value="InsuranceAgentCaptive">Captive</option>
          </optgroup>
          <optgroup label="Individual">
            <option id="Individual" key="Individual" label="Individual" value="Individual">Individual</option>
          </optgroup>
        </select>
      </div>
      <div className="t-flex t-justify-end t-pt-6">
        <button className="t-text-base t-font-semibold t-text-mitre-blue-200 t-uppercase hover:t-text-mitre-blue-300 t-mr-6" onClick={cancelHandler}>{cancelText}</button>
        <button className="t-text-base t-font-semibold t-text-mitre-blue-200 t-uppercase hover:t-text-mitre-blue-300" onClick={submitHandler}>{submitText}</button>
      </div>
    </div>
  );
};

const SimpleModal = (props) => {
  const { logoUri, title, message, contents, bgColorClass, actionText, action } = props;

  const actionHandler = (event) => {
    event.preventDefault();
    action();
  };

  return (
    <div className="t-fixed t-top-0 t-left-0 t-w-screen t-h-screen t-z-1500 t-flex" style={{ backgroundColor: 'rgba(34, 34, 34, 0.5)' }}>
      <div className={`t-relative t-w-100 t-h-auto md:t-min-h-40 t-mx-4 t-my-auto md:t-mx-auto t-flex t-p-12 ${bgColorClass} t-flex-col t-justify-between`}>
        <div className="t-flex t-flex-col">
          <div className="t-flex t-flex-row t-justify-between t-items-center t-mb-6 t-flex-wrap md:t-flex-nowrap">
            <img src={logoUri} className="t-w-max t-mb-3 md:t-mb-0" />
          </div>
          {title && <p className="t-text-4xl t-font-bold t-leading-none">{title}</p>}
          {message && <p className="m-text-body-fw-400-lh-lg t-mt-4 t-mb-4">{message}</p>}
          <div>{contents}</div>
        </div>
        {actionText && (
          <div className="t-flex t-justify-end t-pt-6">
            <button className="t-text-base t-font-semibold t-text-mitre-blue-200 t-uppercase hover:t-text-mitre-blue-300" onClick={actionHandler}>{actionText}</button>
          </div>
        )}
      </div>
    </div>
  );
};

const StickyCheckbox = ({ state, tblKey, isPremium, totalStickiedRows, isSponsoredRow }) => {
  const [buttonState, setState] = useState(state);
  const [stickiedRows, setTotalStickiedRows] = useState(totalStickiedRows);
  const stickyButton = useRef(null);
  const mitreTable = MitreTable.getByTableKey(tblKey);

  const toggleState = () => {
    setState(prevState => {
      if (prevState !== 'true') {
        mitreTable.emit('table-row-stickied', { rowsCount: stickiedRows + 1 });
        return 'true';
      } else {
        mitreTable.emit('table-row-stickied', { rowsCount: isSponsoredRow ? stickiedRows : stickiedRows - 1 });
        return 'false';
      }
    })
  };

  const additionalProps = !isPremium && stickiedRows >= 1 && buttonState !== 'true' && !isSponsoredRow ? {
    'data-controller': 'cta-modal',
    'data-modal-key': 'TableStuckRow',
    'data-modal-url': '/api/dividend/cta-content/',
    'data-modal-location': 'table',
    'data-action': 'click->cta-modal#showModal',
  } : {
    onClick: toggleState,
    'data-action': 'click->table#toggleSticky',
  };

  useEffect(() => {
    mitreTable.on('table-row-stickied', ({ rowsCount }) => {
      setTotalStickiedRows(rowsCount);
    });
  }, [])

  return (
    <button
      ref={stickyButton}
      {...additionalProps}
      checkbox-state={buttonState}
      data-checkbox-state={buttonState}
      data-table-target='stickyCheckbox'
      disabled={stickiedRows >= 3 && isPremium && buttonState !== 'true'}
      className={`${(stickiedRows >= 3 && isPremium && buttonState !== 'true') ? 't-cursor-not-allowed' : ''}`}
    >
      {
        buttonState === 'true' ? (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="t-pointer-events-none">
            <path d="M0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z" fill="#2532D0" />
            <mask id="path-2-inside-1" fill="white">
              <rect width="18" height="18" rx="1" />
            </mask>
            <rect width="18" height="18" rx="1" stroke="#2532D0" strokeWidth="3" strokeLinejoin="round" mask="url(#path-2-inside-1)" />
            <path d="M14 5L7.125 11.8384L4 8.27672" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className="t-pointer-events-none">
            <mask id="path-1-inside-1" fill="white">
              <rect width="18" height="18" rx="1" />
            </mask>
            <rect width="18" height="18" rx="1" stroke="#2532D0" strokeWidth="3" strokeLinejoin="round" mask="url(#path-1-inside-1)" />
          </svg>
        )
      }
    </button>
  )
}

const ArrowUpIcon = () => (
  <span className='sort-arrow t-transition-transform fa fa-angle-down t-mx-1 t-rotate-180 t-self-end'></span>
)

const dimensions = {
  width: 1138
}

const Overlay = () => (
  <span className="t-absolute t-top-0 t-left-0 t-w-full t-h-full t-bg-white t-opacity-50 t-z-50">
  </span>
)

class TableController extends Controller {
  static targets = [
    'scrollSync',
    'sponsoredRow',
    'aggregateRow',
    'stickyRow',
    'stickyAnchor',
    'container',
    'toggleWatchlistButton',
    'toggleStickyCheckbox',
    'stickyCheckbox',
    'blockedCell',
    'row',
    'headerCell',
    'headerContainer',
    'bodyContainer',
    'cell',
    'filterResult',
    'mTable',
    'mainBodyContainer',
    'paginationContainer',
    'tabsFilterContainer',
    'tabsContainer'
  ];

  tableIdentifier = 'm-table';
  tableApiIdentifier = 't';
  withContentTray = false;

  initialize() {
    const {
      tableKeyValue: tableKey,
      collectionKey: initialCollectionKey,
      theme,
      defaultSortBy,
      defaultSortKey
    } = this.element.dataset;

    this._mitreTable = MitreTable.getByTableKey(tableKey);

    // Please see the comment at the bottom of the IF condition.
    // If we indeed wanted (we may still want) to persist the table's params
    // between page loads in localStorage, the best and errorless way
    // to tell if there table's params are not a clean slate would be
    // to check the collection key. Nothing can work without it.
    // If collectionKey hasn't been stored yet, then nothing has been stored
    // yet, which means the table is being seen for the first time.
    // And that's exactly when we should store the default/ inital state.
    //
    // const { collectionKey } = this._mitreTable.getParams();
    // if (!collectionKey) {

    if (true) {
      this._mitreTable.setParam('collectionKey', initialCollectionKey, false);
      this._mitreTable.setParam('sortBy', { [defaultSortKey]: defaultSortBy }, false);

      const defaultSelectionOfFilters = this.constructor.getDefaultSelectionOfFiltersFromDOM(this.element);
      this._mitreTable.setParam('filters', defaultSelectionOfFilters, false);

      const { defaultTabKey } = this.tabsContainerTarget.dataset;
      this._mitreTable.setParam('currentTabKey', defaultTabKey, false);

      // Theme is never changed by the UI, it's a pass-through.
      this._mitreTable.setParam('theme', theme, false);

      // defaultFilters is a pass-through param also.
      const { defaultFilters: defaultFiltersJSON } = this.mTableTarget.dataset;
      let defaultFilters; try { defaultFilters = JSON.parse(defaultFiltersJSON); } catch (e) { defaultFilters = [] };
      this._mitreTable.setParam('defaultFilters', defaultFilters, false);

      // So is specialTheme.
      const { specialTheme } = this.mTableTarget.dataset;
      this._mitreTable.setParam('specialTheme', specialTheme, false);

      // NB! For long time this functionality of storing the table's params was
      // believed to be working. Then, the model layer was phrased as
      // this._mitreTable and it became clear that there's no effect between
      // page loads except for bugs.
      // IMPORTANT! We don't refresh tables according to the preserved params
      // because (a) it's a very bad SEO practice to replace page contents upon
      // page load, and (b) our users didn't seem to even need this functionality.
      // Hence, there's no point in persisting the params.
      // ---
      // this._mitreTable.save();
    }

    if (this.element.dataset['tableIdentifier']) {
      this.tableIdentifier = this.element.dataset['tableIdentifier'];
      SORTED_HEADER_BUTTON_STYLING_CLASSES.push(`${this.tableIdentifier}-col__in-sort`);
      HOVERED_ROW_CLASSES = `${this.tableIdentifier}-body-row-container__hovered`;
    }

    if (this.element.dataset['tableApiIdentifier']) {
      this.tableApiIdentifier = this.element.dataset['tableApiIdentifier'];
    }

    // Expose this controller instance on the DOM
    this.element[this.identifier] = this;

    this.withContentTray = this.mTableTarget.getAttribute('data-with-content-tray') ? this.mTableTarget.getAttribute('data-with-content-tray') == "true" : false;
    this.modalKey = this.element.getAttribute('data-modal-key');
    this.modalKeyword = this.element.getAttribute('data-modal-keyword');
    this.adUnitFullPath = this.element.getAttribute('data-ad-unit-full-path');
    this.defaultSort = {
      key: this.element.getAttribute('data-default-sort-key'),
      value: this.element.getAttribute('data-default-sort-by')
    };
    this.tableDom = this.mTableTarget;
    this.tableRows = {};
    this.totalStickiedRows = 0;
    this.scrollX = 0;
    this.scrollY = 0;

    this.checkDeviceSize();
  }

  async connect() {
    window.MConstants.table[this._mitreTable.tableKey] = {};

    try {
      const response = await Utility.getConfigData({ type: 'current_user' });
      const { premium } = response.data;
      this.isPremium = premium;
    } catch (e) {
      this.isPremium = false;
    }

    this._registerTableUpdateListeners();

    // window.addEventListener('scroll', _.throttle(() => this.stick()), 2000);
    this._stick();

    //this._addSortingIcon();
    this._performTableUIRefresh({ showDefaultBlockedMessageOnMobile: true });
    this._reapplyAnchorShadow();
    this._renderTooltips();
    this._addStylingToDefaultSortColumn();

    if (this.isMobileTablet) {
      this.tabsFilterContainerTarget.classList.remove('t-container');
    }

    this.distanceToTop = this._getExistingStickyHeight();

    window.addEventListener('scroll', _.throttle(() => this.scrollSticky(), 100));

    let interactionsCount = 0;
    const isMF = window.document.location.hostname.indexOf('mutualfunds.com') >= 0;
    this._mitreTable.on('interaction', ({ type } = {}) => {
      if (!isMF) return;
      if (MitreTable.areInteractionsPermanentlyUnlocked()) return;

      if (!MitreTable.areInteractionsLocked()) {
        const interactionTypesToCount = [
          MitreTable.InteractionType.FILTER_CHANGE,
          MitreTable.InteractionType.SORT_CHANGE,
          MitreTable.InteractionType.PAGE_CHANGE,
          MitreTable.InteractionType.TAB_CHANGE,
        ];

        if (interactionTypesToCount.includes(type)) {
          interactionsCount += 1;
          if (interactionsCount > 3) {
            MitreTable.lockInteractions();
          }
        }
      }

      if (MitreTable.areInteractionsLocked()) {
        let modal;

        const showModal = (props) => {
          modal = render(<SimpleModal {...props} />, document.body);
        };

        const closeModal = () => {
          render(null, window.document.body, modal);
        };

        const onEmailCaptureFormSubmit = async ({ email, investorType }) => {
          try {
            // Get current URL without domain (cross-browser compatible)
            const fullUrl = window.location.href;
            const origin = window.location.origin ||
                          (window.location.protocol + "//" + window.location.hostname +
                          (window.location.port ? ':' + window.location.port : ''));
            const currentUrl = fullUrl.substring(origin.length);

            await axios.post('/api/newsletter/', {
              email,
              investor_type: investorType,
              signup_location: currentUrl,
              status: 'subscribed'
            });
            closeModal();
            showModal({
              bgColorClass: 't-bg-mitre-yellow-100',
              logoUri: '/mutualfunds-logo.svg',
              title: 'Thank you for screening with us.',
              actionText: 'Close',
              action: () => closeModal()
            });
            MitreTable.unlockInteractionsPermanently();
          } catch (err) {
            console.log(err)
            // ah, whatever for now.
          }
        };

        showModal({
          bgColorClass: 't-bg-mitre-yellow-100',
          logoUri: '/mutualfunds-logo.svg',
          title: 'Thank you for screening with us.',
          message: 'Continue screening for free by introducing yourself.',
          contents: (
            <EmailCaptureForm
              submitText="Unlock Free Access"
              onSubmit={onEmailCaptureFormSubmit}
              cancelText="Close"
              onCancel={closeModal}
            />
          )
        });
      }
    });
  }

  scrollSticky() {
    const tableBoundingCientRect = this.mTableTarget.getBoundingClientRect();
    const tableHeight = tableBoundingCientRect.height;
    let tableDistanceToTop = tableBoundingCientRect.top;
    let offsetHeights = ((tableDistanceToTop - this.distanceToTop) * -1);

    if (tableDistanceToTop > this.distanceToTop || tableHeight < offsetHeights) {
      if (this.headerContainerTarget.classList.contains('t-absolute')) {
        this.headerContainerTarget.classList.remove(HEADER_Z_INDEX, 't-absolute');
        this.headerContainerTarget.style.top = `0px`;
        this.mainBodyContainerTarget.style.marginTop = `0px`;
        this._stick();
      }
    } else {
      if (!this.headerContainerTarget.classList.contains('t-absolute')) {
        this.headerContainerTarget.classList.add(HEADER_Z_INDEX, 't-absolute');
        this.mainBodyContainerTarget.style.marginTop = `${this._headerHeight()}px`;
      }

      this.headerContainerTarget.style.top = `${offsetHeights}px`;
      offsetHeights += (this._headerHeight() + 1);

      this.stickyAnchorTargets.forEach((el) => {
        const { height } = el.getBoundingClientRect();
        el.style.top = `${offsetHeights}px`;
        offsetHeights += height;
      })
    }
  }

  checkDeviceSize() {
    this.isMobileTablet = ['m', 't'].includes(Utility.getDeviceType());
  }

  _reapplyAnchorShadow() {
    if (this.hasStickyAnchorTarget) {
      this.headerContainerTarget.classList.remove('t-shadow-sticky-anchor');
      this.rowTargets.forEach(element => {
        element.classList.remove('t-shadow-sticky-anchor');
      })
      this.stickyAnchorTargets.forEach((element, index) => {
        element.classList.remove('t-shadow-sticky-anchor');
        if (index == this.stickyAnchorTargets.length - 1) {
          element.classList.add('t-shadow-sticky-anchor');
        }
      })
      if (this.stickyAnchorTargets.length == 1 && this.stickyAnchorTarget.classList.contains('t-hidden')) {
        this.headerContainerTarget.classList.add('t-shadow-sticky-anchor');
      }
    } else {
      this.headerContainerTarget.classList.add('t-shadow-sticky-anchor');
    }
  }

  _performTableUIRefresh = ({
    stick = false,
    showDefaultBlockedMessageOnMobile = false,
    scrollSticky = false
  } = {}) => {
    // this.addShadowToVerticalScroll();
    this.columnMapping = this._mapColumnResize(this.headerContainerTarget);
    this._resizeContainerWidth(this.containerTargets);
    this._resizeCellsInColumns(this.cellTargets);
    if (this.isMobileTablet) {
      this._resizeHeaderCellsInColumns(this.headerCellTargets);
    }
    showDefaultBlockedMessageOnMobile && this._showDefaultBlockedMessageOnMobile();
    this._addWatchlistIcon();
    this._addCheckboxIcon();
    // this.sync(this.scrollSyncTargets);
    stick && this._stick();
    scrollSticky && this.scrollSticky();
  }

  _addStylingToDefaultSortColumn() {
    const sortByKey = this.defaultSort.key;
    const sortButton = this.element.querySelector(`[data-column-key="${sortByKey}"]`);
    // There may not be the default sort column on the current tab.
    if (sortButton) {
      const columnIndex = this._columnIndex(sortButton);
      this._addStylingToSortColumn(columnIndex);
    }
  }

  _refreshStylingOnCurrentSortColumn() {
    const { sortBy } = this._mitreTable.getParams();
    const sortByKey = Object.keys(sortBy)[0];
    let sortButton = this.element.querySelector(`[data-column-key="${sortByKey}"]`);
    // There may not be a current sort column on a newly loaded tab!
    if (sortButton) {
      this._addStyleChangesToSortButton(sortButton);
      const columnIndex = this._columnIndex(sortButton);
      this._addStylingToSortColumn(columnIndex);
    }
  }

  _registerTableUpdateListeners() {
    EventManager.onNewEvent('watchlist-updated', () => {
      if (this._mitreTable.tableKey.includes('Watchlist-FundsList')
        || this._mitreTable.tableKey.includes('Watchlist-StocksList')) {
        this._mitreTable.emit('table-body-update', { pagination: 1 });
      }
    });

    this._mitreTable.on('table-header-update', async ({ pagination }) => {
      const { filters, currentTabKey, sortBy, collectionKey, theme, defaultFilters } = this._mitreTable.getParams();

      this.headerContainerTarget.classList.add('t-relative')
      const overlay = render(<Overlay />, this.headerContainerTarget)
      const params = {
        uuid: this._mitreTable.tableKey,
        filters,
        tab: currentTabKey,
        collection: collectionKey,
        sort_by: sortBy,
        theme,
        page: pagination,
        default_filters: defaultFilters
      }
      try {
        // Fetch New Header DOM Data from backend
        const result = await RequestQueue.addToQueue({
          url: `/api/${this.tableApiIdentifier}/header.html/`,
          method: 'post',
          data: this._parseParams(params)
        });
        const parser = new DOMParser();

        // get existing element
        const prev = this.headerContainerTarget;

        // create the new element
        const fragment = parser.parseFromString(result.data, 'text/html').body;

        // render on screen - update the DOM
        const newNode = morphdom(prev, fragment);

        morphdom(newNode, newNode.firstChild)

        this.columnMapping = this._mapColumnResize(this.headerContainerTarget);
        // this.addShadowToVerticalScroll();
        this._resizeContainerWidth(this.containerTargets);
        this._resizeCellsInColumns(this.cellTargets);
        if (this.isMobileTablet) {
          this._resizeHeaderCellsInColumns(this.headerCellTargets);
        }
        //this._addSortingIcon();

        this._refreshStylingOnCurrentSortColumn();

        // this.sync(this.scrollSyncTargets);
      } catch (e) {
        render(null, this.headerContainerTarget, overlay);
      }
    })

    const handleTableBodyUpdateComplete = async (options = {}) => {
      const { filters, collectionKey, theme, defaultFilters } = this._mitreTable.getParams();

      const response = await RequestQueue.addToQueue({
        url: `/api/${this.tableApiIdentifier}/total_count/`,
        method: 'post',
        data: {
          filters,
          uuid: this._mitreTable.tableKey,
          collection: collectionKey,
          default_filters: defaultFilters,
          theme
        }
      });

      const { data } = response;
      const { total } = data;

      this.filterResultTargets.forEach(filterResult => {
        filterResult.textContent = total;
      })

      if (!options.disableRefresh) {
        this._mitreTable.emit('table-sponsor-ad-refresh');

        // We trigger this one event here instead of in Ad Refresh event handler,
        // because we don't know if DFP will send us a new ads or not
        // if not, this will refresh the sponsored rows layout according to the new tab
        // if yes, the new Ads content should trigger the ads refresh by default
        // then we don't need to handle this event.
      }

      this.element.dataset['dataState'] = 'complete'
      this.scrollRow();

      const columnIndex = !!options.sortedColumnIndex
        ? options.sortedColumnIndex
        : this._getCurrentColumnSortIndex();

      this._addStylingToSortColumn(columnIndex);
      this.scrollSticky();
    };

    this._mitreTable.on('table-body-update', async ({ pagination, options = {} }) => {
      const {
        collectionKey,
        currentTabKey,
        sortBy,
        filters,
        theme,
        specialTheme,
        defaultFilters
      } = this._mitreTable.getParams();

      this.element.dataset['dataState'] = 'loading'
      this.bodyContainerTarget.classList.add('t-relative')
      const overlay = render(<Overlay />, this.bodyContainerTarget)
      const params = {
        uuid: this._mitreTable.tableKey,
        default_filters: defaultFilters,
        filters,
        tab: currentTabKey,
        page: pagination,
        collection: collectionKey,
        sort_by: sortBy,
        theme,
        modal_key: this.modalKey,
        modal_keyword: this.modalKeyword,
        special_theme: specialTheme,
        ad_unit_full_path: this.adUnitFullPath,
        no_content_tray_ads_in_table: this.withContentTray
      }
      // Fetch New Header DOM Data from backend
      try {
        const result = await RequestQueue.addToQueue({
          url: `/api/${this.tableApiIdentifier}/body.html/`,
          method: 'post',
          data: this._parseParams(params)
        });

        if (options.ignoreFirstColumn) {
          // update overlay ui without hiding first column
        }
        const parser = new DOMParser();

        // get existing element
        const prev = this.bodyContainerTarget;

        // create the new element
        const fragment = parser.parseFromString(result.data, 'text/html').body;

        // unmount preact components
        this._unmountComponents();

        // render on screen - update the DOM
        const newNode = morphdom(prev, fragment);

        morphdom(newNode, newNode.firstChild)

        this._performTableUIRefresh({ showDefaultBlockedMessageOnMobile: true });

        handleTableBodyUpdateComplete(options);
      } catch (e) {
        render(null, this.bodyContainerTarget, overlay);
        this.element.dataset['dataState'] = 'error'
      }
    });

    this._mitreTable.on('table-sticky-row-update-complete', () => {
      this._performTableUIRefresh({ stick: true });
    });

    this._mitreTable.on('table-sponsor-row-update-complete', () => {
      this._performTableUIRefresh({ stick: true, scrollSticky: true });
    });

    this._mitreTable.on('table-agg-row-update-complete', () => {
      this._performTableUIRefresh({ stick: true });
    });

    this._mitreTable.on('table-sponsor-ad-refresh', () => {
      const sponsoredRowAds = [];
      this.element.querySelectorAll('[data-controller*="ad-unit"]').forEach(e => {
        const sponsorRow = window.MConstants.adUnits[e.dataset.adUnitAdUnit];
        if (sponsorRow) {
          sponsoredRowAds.push(sponsorRow)
        }
      });
      EventManager.emit('mitre-ad-refresh', {
        adUnits: sponsoredRowAds.flat(),
        allVisibleAds: true
      });
    })

    this._mitreTable.on('table-row-stickied', ({ rowsCount }) => {
      this.totalStickiedRows = this.isPremium ? Math.min(rowsCount, 3) : Math.min(rowsCount, 1);
    });
  }

  _addSortingIcon() {
    this.headerCellTargets.forEach(e => {
      const sortButton = e.querySelector('button');
      // If there is a sort button
      // And there is no data attribute of unsortable
      if (sortButton && _.isNil(e.getAttribute('data-table-header-unsortable'))) {
        const arrowIcon = sortButton.querySelector('.arrow-icon');
        render(<ArrowUpIcon />, arrowIcon.parentNode, arrowIcon);
      }
    })
  }

  _addWatchlistIcon() {
    setTimeout(() => {
      this.toggleWatchlistButtonTargets.forEach(e => {
        try {
          const [symbol, securityType] = e.closest('[data-table-target="row"]').getAttribute('data-uuid').split("**");
          render(<WatchlistButton state={e.getAttribute('data-watchlist-state')} isPremium={this.isPremium} symbol={symbol} securityType={securityType} />, e.parentNode, e);
        } catch (e) {
          // skip with error
        }
      })
    }, 50);
  }

  _addCheckboxIcon() {
    setTimeout(() => {
      this.toggleStickyCheckboxTargets.forEach(e => {
        render(<StickyCheckbox state={e.getAttribute('data-checkbox-state')}
          isSponsoredRow={e.getAttribute('data-is-sponsored-row')}
          isPremium={this.isPremium}
          tblKey={this._mitreTable.tableKey}
          totalStickiedRows={this.totalStickiedRows} />, e.parentNode, e);
      })
    }, 50);
  }

  _unmountComponents() {
    this.bodyContainerTarget.querySelectorAll(`.${this.tableIdentifier}-body-row-container [data-table-target*="stickyCheckbox"]`).forEach(e => {
      render(null, e.parentNode, e)
    })
  }

  _showDefaultBlockedMessageOnMobile() {
    if (this.isMobileTablet) {
      this.blockedCellTargets.forEach(element => {
        this._showBlockedMessage(element);
      })
    }
  }

  scrollRow(event) {
    let element = this.mTableTarget;
    let scrollLeft = element.scrollLeft;
    if (event) {
      element = event.target;
      scrollLeft = element.scrollLeft;
    }

    this.scrollSyncTargets
      .filter(el => el != element)
      .forEach(el => { el.scroll({ left: scrollLeft }) })

    const leftStickyItems = document.querySelectorAll(`.${this.tableIdentifier}-body-cell__sticky`);

    for (let idx = 0; idx < leftStickyItems.length; idx++) {
      let item = leftStickyItems[idx];
      if (scrollLeft == 0) {
        if (item.classList.contains('t-shadow-outline-right')) {
          item.classList.remove('t-shadow-outline-right');
        }
      } else {
        if (!item.classList.contains('t-shadow-outline-right')) {
          item.classList.add('t-shadow-outline-right');
        }
      }
    }
  }

  _showBlockedMessage(element) {
    const message = document.createElement('div')
    const backgroundColor = this.isMobileTablet ? 't-bg-white' : 't-bg-mitre-green-100';
    message.classList.add('t-flex', 't-absolute', 't-w-full', 't-h-full', 't-top-0', 't-left-0', 't-py-2', 't-px-2', 't-items-center', 'locked', backgroundColor, `${this.tableIdentifier}-message__blocked`)
    const button = document.createElement('button');
    button.classList.add('t-border-1', 't-border-mitre-blue-200', 't-w-full', 't-py-3', 't-w-full', 't-flex', 't-justify-center', 't-text-sm', 't-text-transparent')
    const { modalType, modalKey, modalUrl, modalLocation, resource } = element.dataset;
    button.dataset['modalType'] = modalType || 'default';
    button.dataset['modalKey'] = modalKey;
    button.dataset['modalUrl'] = modalUrl;
    button.dataset['modalLocation'] = modalLocation;
    button.dataset['resource'] = resource || '{}';
    button.setAttribute('data-controller', 'cta-modal');
    button.setAttribute('data-action', 'click->cta-modal#showModal')
    button.textContent = 'Locked';
    message.appendChild(button);
    element.appendChild(message);
  }

  _hoverRow(rowEl) {
    rowEl.classList.add(HOVERED_ROW_CLASSES);
    if (!this.isMobileTablet) {
      Array.from(rowEl.getElementsByClassName(...SORTED_CELL_STYLING_CLASSES))
        .forEach((el) => el.classList.remove(SORTED_CELL_BACKGROUND_CLASS));
    }
    const blockedCells = rowEl.querySelectorAll('[data-table-target*="blockedCell"]');
    blockedCells.forEach((el) => this._showBlockedMessage(el));
  }

  _unhoverRow(rowEl) {
    rowEl.classList.remove(HOVERED_ROW_CLASSES)
    Array.from(rowEl.getElementsByClassName(SORTED_CELL_MARK_CLASS)).forEach((el) => el.classList.add(SORTED_CELL_BACKGROUND_CLASS));
    if (!this.isMobileTablet) {
      const blockedMessages = rowEl.querySelectorAll(`.${this.tableIdentifier}-message__blocked`);
      blockedMessages.forEach((el) => el.remove());
    }
  }

  showHoveredRow(e) {
    const row = e.target.closest(`.${this.tableIdentifier}-row`);
    this._hoverRow(row);
  }

  exitHoveredRow(e) {
    const rowEl = e.target.closest(`.${this.tableIdentifier}-row`);
    this._unhoverRow(rowEl);
  }

  sort(e, overrideSort, triggerSortEvent = true) {
    this._mitreTable.emit('interaction', { type: MitreTable.InteractionType.SORT_CHANGE });
    if (MitreTable.areInteractionsLocked()) return;

    let button = (overrideSort && overrideSort.button ? overrideSort.button : null) || (e ? e.target.closest('button') : null);
    if (button) {
      const columnIndex = this._columnIndex(button);
      let overrideSortDirection = overrideSort ? overrideSort.direction : null;
      const columnKey = button.getAttribute('data-column-key');
      const columnSortDirection = this._getSortDirection(button, overrideSortDirection);

      this._toggleSortDirection(button, columnSortDirection, overrideSortDirection);

      this._mitreTable.setParam('sortBy', { [columnKey]: columnSortDirection });

      this._addStyleChangesToSortButton(button);
      this._addStylingToSortColumn(columnIndex);

      this._mitreTable.emit('table-body-update', {
        pagination: 1, options: {
          sortedColumnIndex: columnIndex,
          disableRefresh: !!overrideSort
        }
      });
    }
  }

  _getSortDirection(button, overrideSortDirection) {
    if (overrideSortDirection) {
      return overrideSortDirection;
    }

    const currentDirection = button.getAttribute('data-column-dir');
    const defaultDirection = button.getAttribute('data-column-default-sort-direction');

    if (defaultDirection && !currentDirection) {
      return defaultDirection;
    }

    return currentDirection == 'desc' ? 'asc' : 'desc';
  }

  _toggleSortDirection(button, newDirection, overrideDirection) {
    // Clear all sort direction attributes on all headers except current one
    this.headerCellTargets.forEach(e => {
      const sortButton = e.querySelector('button');
      if (sortButton && sortButton != button) {
        sortButton.removeAttribute('data-column-dir');
      }
    })
    if (overrideDirection) {
      button.setAttribute('data-column-dir', overrideDirection);
    } else {
      button.setAttribute('data-column-dir', newDirection);
    }

  }

  _columnIndex(button) {
    const buttonCell = button.closest(`.${this.tableIdentifier}-body-cell`) ?
      button.closest(`.${this.tableIdentifier}-body-cell`) :
      button.closest(`.${this.tableIdentifier}-body-cell__sticky`);
    return buttonCell.getAttribute('data-table-header-column-index');
  }

  _addStylingToSortColumn(columnIndex) {
    if (columnIndex < 0) return;

    this.cellTargets.forEach((el) => {
      if (el.getAttribute('data-table-column-index') == columnIndex) {
        this._addStylingToCell(el);
      } else {
        this._removeStylingFromCell(el);
      }
    });

    this.headerCellTargets.forEach((el) => {
      if (el.getAttribute('data-table-header-column-index') == columnIndex) {
        this._addStylingToCell(el);
      } else {
        this._removeStylingFromCell(el);
      }
    });
  }

  _addStylingToCell(element) {
    if (element) {
      element.classList.add(...SORTED_CELL_STYLING_CLASSES)
      element.classList.remove(...UNSORTED_CELL_STYLING_CLASSES)
    }
  }

  _removeStylingFromCell(element) {
    if (element) {
      element.classList.remove(...SORTED_CELL_STYLING_CLASSES)
      element.classList.add(...UNSORTED_CELL_STYLING_CLASSES)
    }
  }

  _addStyleChangesToSortButton(button) {
    this.headerCellTargets.forEach(e => {
      const sortButton = e.querySelector('button');
      if (sortButton) {
        sortButton.classList.remove(...SORTED_HEADER_BUTTON_STYLING_CLASSES)
      }
    })
    button.classList.add(...SORTED_HEADER_BUTTON_STYLING_CLASSES)
  }

  _resizeContainerWidth(elements) {
    elements.forEach(el => {
      el.style.width = `${dimensions.width}px`;
      el.style.minWidth = `${dimensions.width}px`;
    })

    if (this.hasPaginationContainerTarget) {
      const { width } = this.paginationContainerTarget.getBoundingClientRect();
      this.paginationContainerTarget.style.left = `calc(50% - ${width / 2}px)`;
    }
  }

  _resizeCellsInColumns(elements) {
    let desktopDevice = Utility.getDeviceType() === 'dt';
    elements.forEach((el) => {
      if (desktopDevice) {
        el.style.width = el.getAttribute('data-cell-dimension');
      } else {
        this._findResizeDimensions(elements, 'data-table-column-index');
      }
    })
  }

  _resizeHeaderCellsInColumns(elements) {
    this._findResizeDimensions(elements, 'data-table-header-column-index');
  }

  _findResizeDimensions(elements, dataTarget) {
    elements.forEach((el) => {
      let currentColumnIndex = el.getAttribute(dataTarget);
      let currentCellDimension = parseFloat(el.getAttribute('data-cell-dimension').replace(/%/, ''));
      if (!el.classList.contains(`${this.tableIdentifier}-ignore-resize`)) {
        if (currentColumnIndex == "1") {
          el.style.width = "15%";
        } else if (currentColumnIndex == "0") {
          el.style.width = "6%";
        } else {
          if (this.columnMapping[currentColumnIndex]) {
            el.style.width = `${currentCellDimension + this.columnMapping[currentColumnIndex]}%`;
          } else {
            el.style.width = `${currentCellDimension}%`;
          }
        }
      } else {
        el.style.width = `${currentCellDimension}%`;
      }
    })
  }

  _mapColumnResize(currentTarget) {
    let remainder = parseFloat(currentTarget.querySelector("[data-table-header-column-index='1']").getAttribute('data-cell-dimension').replace(/%/, ''));
    let columnsNumber = currentTarget.getAttribute('data-table-columns-number');
    let mapping = {}
    let columnIndex = 2;

    remainder = (remainder - 17)

    for (let idx = 0; idx < remainder; idx++) {
      if (mapping[columnIndex]) {
        mapping[columnIndex] += 1;
      } else {
        mapping[columnIndex] = 1
      }

      if (columnIndex == columnsNumber - 1) {
        columnIndex = 2;
      } else {
        columnIndex++
      }
    }

    return mapping
  }

  _animate({ timing, draw, duration }) {
    let start = performance.now();

    requestAnimationFrame(function animate(time) {
      // timeFraction goes from 0 to 1
      let timeFraction = (time - start) / duration;
      if (timeFraction > 1) timeFraction = 1;

      // calculate the current animation state
      let progress = timing(timeFraction)

      draw(progress); // draw it

      if (timeFraction < 1) {
        requestAnimationFrame(animate);
      }

    });
  }

  toggleSticky(e, staticClick = false) {
    let target;
    if (staticClick) {
      target = staticClick;
    } else {
      target = e.target.closest('button');
    }

    const checkState = target.getAttribute('data-sticky-checkbox-state-value') === 'true'
    const row = target.closest('[data-table-target*="row"]');

    if (checkState) {
      // Move the row to after the sticky anchor, and make this row the anchor
      const deltaY = this._getDeltaY(row, () => {
        // Create a placeholder area for the row to return
        const placeholderElement = document.createElement('div');
        placeholderElement.style.display = 'none';
        placeholderElement.setAttribute('data-original-row-index', row.getAttribute('data-table-row-index'))
        row.parentNode.insertBefore(placeholderElement, row);
        // Find the last sticky anchor
        if (this.hasStickyAnchorTarget) {
          const lastStickyAnchor = this.stickyAnchorTargets[this.stickyAnchorTargets.length - 1];
          // Move the row to sticky area
          this._insertAfter(row, lastStickyAnchor);
        } else {
          const bodyContainer = row.closest(`.${this.tableIdentifier}-body-container`)
          bodyContainer.insertBefore(row, bodyContainer.firstChild)
        }
        this._removeStylingFromCell(row.querySelector(`[data-table-column-index="${this._getCurrentColumnSortIndex()}"]`))
        row.dataset.controller = row.dataset.controller ? row.dataset.controller + ' table-sticky-row' : 'table-sticky-row';
        row.dataset.tableTarget = row.dataset.tableTarget ? row.dataset.tableTarget + ' stickyRow stickyAnchor' : 'stickyRow stickyAnchor';
        row.dataset.tableIdentifier = this.tableIdentifier;
        row.dataset.tableApiIdentifier = this.tableApiIdentifier;
        this._stick();
      })
      row.style.transform = `translateY(${-deltaY}px)`;
      this._animate({
        duration: 500,
        timing(timeFraction) {
          return timeFraction;
        },
        draw(progress) {
          row.style.transition = 'transform 50ms linear';
          row.style.transform = `translateY(${(1 - progress) * -deltaY}px)`;
        }
      })

    } else {
      const originalRow = this.element.querySelector(`[data-original-row-index="${row.getAttribute('data-table-row-index')}"]`);
      if (!originalRow) {
        if (row.previousElementSibling) {
          let comboBanner = row.previousElementSibling;
          if (comboBanner.classList.contains('mp-table-sponsored-publisher-row-combo')) {
            comboBanner.remove();
          }
        }
        row.remove();
        this._stick();
      } else {
        this._removeSticky(row)
        this._insertAfter(row, originalRow);
        this._stick();
        originalRow.remove();
      }

      this._unhoverRow(row);
    }

    this._refreshStylingOnCurrentSortColumn();
    this.scrollSticky();
  }

  _stick() {
    this._stickRowsCalculation();
    this._reapplyAnchorShadow();
    this._refreshStylingOnCurrentSortColumn();
  }

  _stickRowsCalculation() {
    const elements = this.stickyAnchorTargets;
    let offsetHeights = (this._headerHeight() + 2);
    elements.forEach((el, index) => {
      const { height } = el.getBoundingClientRect();
      el.style.top = `${offsetHeights}px`;
      offsetHeights += height;
      el.classList.add('t-absolute');
      el.style.zIndex = 20 + index;
      el.classList.add('t-bg-white');
    })
    this.bodyContainerTarget.style.marginTop = `${offsetHeights - this._headerHeight()}px`;
  }

  _getExistingStickyHeight() {
    // navigation bar, ticker nav
    const navs = document.querySelectorAll('.sticky-element');
    let headerHeight = 0;
    navs.forEach(e => {
      const elementPositionProperty = getComputedStyle(e)['position'];
      if (e.offsetParent != null && elementPositionProperty == 'sticky') {
        const { height } = e.getBoundingClientRect();
        headerHeight += height;
      }
    })
    const otherStickyTargets = this.element.querySelectorAll('[data-sticky-index]')
    otherStickyTargets.forEach(e => {
      const stickyDisabled = window.matchMedia(e.getAttribute('data-disable-sticky-query')).matches;
      if (!stickyDisabled) {
        const { height } = e.getBoundingClientRect();
        headerHeight += height;
      }
    })
    return headerHeight;
  }

  _removeSticky(element) {
    element.removeAttribute('style');
    element.classList.remove('t-absolute');
    element.classList.remove('t-bg-white');
    element.style.zIndex = '';
    element.style.top = '';
    element.dataset.tableTarget = 'row';
    element.removeAttribute('data-controller');
  }

  _getDeltaY(element, movementFunction) {
    const { y } = element.getBoundingClientRect();
    movementFunction();
    const { y: newY } = element.getBoundingClientRect();
    return newY - y;
  }

  _insertAfter(element, anchor) {
    anchor.parentNode.insertBefore(element, anchor.nextSibling);
  }

  _getCurrentColumnSortIndex() {
    const sortedColumnHeaderButton = this.element.querySelector(`.${this.tableIdentifier}-col__in-sort`);
    if (sortedColumnHeaderButton) {
      const columnIndex = sortedColumnHeaderButton.closest(`.${this.tableIdentifier}-body-cell`).getAttribute('data-table-header-column-index');
      return columnIndex;
    }
    return -1;
  }

  _parseParams(params) {
    if (params.page && params.page == 'currentPage') {
      const paginationElement = this.element.querySelector('[data-table-pagination-current-page]');
      if (paginationElement) {
        const page = paginationElement.getAttribute('data-table-pagination-current-page');
        params.page = parseInt(page);
      } else {
        params.page = 1;
      }
    }
    return params;
  }

  _renderTooltips = () => {
    let el = this.element;
    delegate(el, {
      onShow(instance) {
        const reference = instance.reference;
        const id = reference.getAttribute('data-template');
        const template = document.getElementById(id);
        instance.setContent(template.innerHTML);
      },
      target: '.dynamic-tooltip',
      allowHTML: true,
      interactive: true,
      maxWidth: 240,
      theme: 'light',
      placement: 'bottom'
    });
  }

  _headerHeight() {
    return this.headerContainerTarget.clientHeight;
  }

  // NB! Mind that this logic is different than the one in collection_controller.
  // Here, we don't pay attention to disabled or enabled filter groups; we just read them all.
  // For the time being, that is not a problem as there's no requirement to load any table with
  // its filters disabled.
  static getDefaultSelectionOfFiltersFromDOM(domEl) {
    const filterButtonsNodeList = domEl.querySelectorAll(`[data-filter-type]`);
    const defaultSelection = Array.from(filterButtonsNodeList)
      .map((el) => [el.dataset.filterKey, el.dataset.filterValue, el.dataset.filterType, el.dataset.filterSelected])
      .filter((tuple) => Boolean(tuple[3]));

    return Object.fromEntries(defaultSelection.map(([filterKey, filterValue, filterType]) => [
      filterKey,
      {
        filterKey,
        selected: true,
        value: filterValue,
        type: filterType
      }
    ]));
  }
}

export default TableController;
